import {
  Field,
  Link,
  LinkField,
  useSitecoreContext,
  Text,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { useRouter } from "next/router";
import { Chatbot } from "@repo/nuance-chat";
import { SierraAgent } from "@repo/sierra-chat";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import { Button } from "@repo/ui/button";
import * as Flex from "@repo/ui/flex";
import { SpinnerIcon } from "@/theme/icons/spinner";
import { useChatbotContext } from "../../../providers/chatbot-provider";
import { isMobile } from "../../../utils";
import styles from "./get-in-touch.module.css";

type ActionButtonsProps = ComponentProps & {
  fields: {
    data: {
      contextItem: {
        chatOnlineButton: Field<string>;
        myAccountButton: Field<string>;
        myAccountLink: LinkField;
      };
    };
  };
};

const ActionButtons = ({
  fields: {
    data: {
      contextItem: { myAccountButton, myAccountLink },
    },
  },
}: ActionButtonsProps) => {
  const router = useRouter();
  const { sitecoreContext } = useSitecoreContext();
  const sxaTags = sitecoreContext.route?.fields?.SxaTags as
    | {
        name: string;
      }[]
    | undefined;

  const mobile = isMobile();

  const {
    chatbotStatus,
    handleChatBotStatusChange,
    isChatbotActive,
    isChatbotLoading,
  } = useChatbotContext();

  const sierraEnabledQueryParam = router.query["sierra-enabled"];
  const isSierraEnabled =
    sierraEnabledQueryParam === "true"
      ? true
      : sierraEnabledQueryParam !== undefined
        ? false
        : (sxaTags?.some((tag) => tag.name === "Sierra") ?? false);

  return (
    <Flex.Container
      className={styles.actionButtonContainer}
      column={!!mobile}
      gap="lg"
    >
      {!isChatbotActive && (
        <Button
          className={clsx("typographyLabel3", styles.actionButton)}
          size="large"
          variant="primary"
          alignment="start"
          asChild
        >
          <Link field={myAccountLink || ""}>
            <Text field={myAccountButton} />
          </Link>
        </Button>
      )}
      {isSierraEnabled ? (
        <SierraAgent handleChatBotStatusChange={handleChatBotStatusChange} />
      ) : (
        <>
          {isChatbotLoading ? <SpinnerIcon label="Loading..." /> : null}
          <Chatbot
            onStatusChange={handleChatBotStatusChange}
            status={chatbotStatus}
          />
        </>
      )}
    </Flex.Container>
  );
};

export default ActionButtons;
